<template>
	<div>
		<button class="sound" :class="soundStatus ? 'animate' : ''" @click="toggle()">
			<img v-if="soundStatus" src="../../assets/icons/sound-wave-icon.svg" alt="" />
			<img v-else src="../../assets/icons/sound-wave-off-icon.svg" alt="" />
		</button>
	</div>
</template>
<style lang="scss" scoped>
	button.sound {
		padding: 0;
		height: 2.5rem;
		img {
			height: 100%;
			will-change: transform;
			transition: transform 0.3s ease;
		}
		&:hover {
			img {
				transform: scale(1.4);
			}
		}

		&.animate {
		}
	}
</style>
<script>
	import { mapActions, mapState } from "vuex";
	export default {
		computed: {
			...mapState(["soundStatus"]),
		},
		methods: {
			...mapActions(["toggleSound"]),
			toggle() {
				this.toggleSound({ status: !this.soundStatus });
			},
		},
	};
</script>
